import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { DEFAUT_VALUEE_FILTERS } from "../../../../../components/common/Modal/ArchiveOrderFiltersModal/constants";
import { Customers } from "../../interface";

import { State, OrdersData } from "./interface";

const initialState: State = {
	orders: {},
};

const setOrdersDataModal: ReduxReducer<State, State["orders"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);

		if (!Number.isNaN(numericId)) {
			const existing = state.orders[numericId];
			state.orders[numericId] = {
				...(existing ?? { byMultyFilters: DEFAUT_VALUEE_FILTERS }),
				...data,
			};
		}
	}
};

const setByMultyFilters: ReduxReducer<
	State,
	{ id?: number; filters?: OrdersData["byMultyFilters"] }
> = (state, action) => {
	const { id, filters } = action.payload;
	const numericId = Number(id);

	if (Number.isNaN(numericId) || !filters) return;

	const existing = state.orders[numericId];

	state.orders[numericId] = {
		...(existing ?? { models: [] }),
		byMultyFilters: filters,
	};
};

const customersClientsDataModal = createSlice({
	name: Customers.ConstantCustomersSlice.CLIENTS_DATA_MODAL,
	initialState,
	reducers: {
		setOrdersDataModal,
		setByMultyFilters,
	},
});

export const customersClientsDataModalAction =
	customersClientsDataModal.actions;
export const customersClientsDataModalReducer =
	customersClientsDataModal.reducer;
export type customersClientsDataModalState = State;

export default customersClientsDataModal;
